import React from "react"
import { Link } from "react-router-dom"
import { List } from "semantic-ui-react"

//component
import { notilogin } from "../../containers/Function/Notification.function"

//material ui
import Divider from "@material-ui/core/Divider"
import ListItem from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import ExpandLess from "@material-ui/icons/ExpandLess"
import ExpandMore from "@material-ui/icons/ExpandMore"
import Collapse from "@material-ui/core/Collapse"
import HomeIcon from "@material-ui/icons/Home"
import AssignmentIcon from "@material-ui/icons/Assignment"
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn"
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd"
import LanguageIcon from "@material-ui/icons/Language"
import AssessmentIcon from "@material-ui/icons/Assessment"
import AccountCircle from "@material-ui/icons/AccountCircle"
import PhoneIcon from "@material-ui/icons/Phone"
import GTranslateIcon from "@material-ui/icons/GTranslate"
import LockIcon from "@material-ui/icons/Lock"
import LockOpenIcon from "@material-ui/icons/LockOpen"
import PersonAddIcon from "@material-ui/icons/PersonAdd"
import ImportContactsIcon from "@material-ui/icons/ImportContacts"
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks"
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount"
import HelpIcon from "@material-ui/icons/Help"

export const sideList = (
	classes,
	t,
	projectopen,
	Translateopen,
	Profileopen,
	handleClick,
	toggleDrawer,
	i18n,
	user,
	handleLogout
) => {
	return Object.keys(user).length === 0 ? (
		<div className={classes.list}>
			<List className={classes.root2}>
				<Link to="/" aria-label="home">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<HomeIcon />
						</ListItemIcon>
						<ListItemText primary={t("Breadcrumb.Home")} />
					</ListItem>
				</Link>
				<Link to="/Features" aria-label="Features">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<AssignmentIcon />
						</ListItemIcon>
						<ListItemText primary={t("NavBarDesktop.NavBarDesktopFeatures")} />
					</ListItem>
				</Link>
				<Link to="/Services" aria-label="Services">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<AssignmentTurnedInIcon />
						</ListItemIcon>
						<ListItemText primary={t("NavBarDesktop.NavBarDesktopServices")} />
					</ListItem>
				</Link>
				<Link to="/GlobalProjects" aria-label="GlobalProjects">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<AssessmentIcon />
						</ListItemIcon>
						<ListItemText primary={t("NavBarDesktop.NavBarDesktopProjects")} />
					</ListItem>
				</Link>
				<Link to="/Community" aria-label="Community">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<SupervisorAccountIcon />
						</ListItemIcon>
						<ListItemText primary={t("NavBarDesktop.NavBarDesktopCommunity")} />
					</ListItem>
				</Link>
				<a href="https://blogs.mixedmodel.academy/">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<LibraryBooksIcon />
						</ListItemIcon>
						<ListItemText primary={t("Blogs.Blogs")} />
					</ListItem>
				</a>
				<Link to="/Tutorial" aria-label="Help">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<ImportContactsIcon />
						</ListItemIcon>
						<ListItemText primary={t("NavBarDesktop.NavBarDesktopHelp")} />
					</ListItem>
				</Link>
				<Link
					to="/Document/How-to-Create-a-Project-in-MMA/1"
					aria-label="Guides"
				>
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<HelpIcon />
						</ListItemIcon>
						<ListItemText primary={t("Menu.Document")} />
					</ListItem>
				</Link>
			</List>
			<Divider />
			<List>
				<Link to="/Signin" aria-label="Signin">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<LockIcon />
						</ListItemIcon>
						<ListItemText primary={t("NavBarDesktop.NavBarDesktopSignIn")} />
					</ListItem>
				</Link>
				<Link to="/Signup" aria-label="Signup">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<PersonAddIcon />
						</ListItemIcon>
						<ListItemText primary={t("NavBarDesktop.NavBarDesktopSignUp")} />
					</ListItem>
				</Link>
				<ListItem
					button
					onClick={() => {
						toggleDrawer("left", false)
						notilogin(t)
					}}
				>
					<ListItemIcon>
						<PhoneIcon />
					</ListItemIcon>
					<ListItemText primary={t("NavBarDesktop.NavBarDesktopContactUs")} />
				</ListItem>
				<ListItem button onClick={(event) => handleClick(event, "Translate")}>
					<ListItemIcon>
						<GTranslateIcon />
					</ListItemIcon>
					<ListItemText primary={t("Menu.Language")} />
					{Translateopen ? <ExpandLess /> : <ExpandMore />}
				</ListItem>
				<Collapse in={Translateopen}>
					<ListItem
						button
						className={classes.nested}
						onClick={(event) => {
							i18n.changeLanguage("en")
							toggleDrawer("left", false)
						}}
					>
						<ListItemIcon>
							<GTranslateIcon />
						</ListItemIcon>
						<ListItemText inset primary="ENG" />
					</ListItem>

					<ListItem
						button
						className={classes.nested}
						onClick={(event) => {
							i18n.changeLanguage("th")
							toggleDrawer("left", false)
						}}
					>
						<ListItemIcon>
							<GTranslateIcon />
						</ListItemIcon>
						<ListItemText inset primary="THA" />
					</ListItem>
				</Collapse>
			</List>
		</div>
	) : (
		<div className={classes.list}>
			<List className={classes.root2}>
				<Link to="/" aria-label="home">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<HomeIcon />
						</ListItemIcon>
						<ListItemText primary={t("Breadcrumb.Home")} />
					</ListItem>
				</Link>
				<Link to="/Features" aria-label="Features">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<AssignmentIcon />
						</ListItemIcon>
						<ListItemText primary={t("NavBarDesktop.NavBarDesktopFeatures")} />
					</ListItem>
				</Link>
				<Link to="/Services" aria-label="Services">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<AssignmentTurnedInIcon />
						</ListItemIcon>
						<ListItemText primary={t("NavBarDesktop.NavBarDesktopServices")} />
					</ListItem>
				</Link>
				<ListItem button onClick={(event) => handleClick(event, "project")}>
					<ListItemIcon>
						<AssessmentIcon />
					</ListItemIcon>
					<ListItemText primary={t("NavBarDesktop.NavBarDesktopProjects")} />
					{projectopen ? <ExpandLess /> : <ExpandMore />}
				</ListItem>
				<Collapse in={projectopen}>
					<Link to="/GlobalProjects" aria-label="GlobalProjects">
						<ListItem
							button
							className={classes.nested}
							onClick={toggleDrawer("left", false)}
						>
							<ListItemIcon>
								<LanguageIcon />
							</ListItemIcon>
							<ListItemText
								inset
								primary={t("NavBarDesktop.NavBarDesktopGlobalProjects")}
							/>
						</ListItem>
					</Link>
					<Link to="/MyProjects" aria-label="MyProjects">
						<ListItem
							button
							className={classes.nested}
							onClick={toggleDrawer("left", false)}
						>
							<ListItemIcon>
								<AssignmentIndIcon />
							</ListItemIcon>
							<ListItemText
								inset
								primary={t("NavBarDesktop.NavBarDesktopMyProjects")}
							/>
						</ListItem>
					</Link>
				</Collapse>
				<Link to="/Community" aria-label="Community">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<SupervisorAccountIcon />
						</ListItemIcon>
						<ListItemText primary={t("NavBarDesktop.NavBarDesktopCommunity")} />
					</ListItem>
				</Link>
				<a href="https://blogs.mixedmodel.academy/">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<LibraryBooksIcon />
						</ListItemIcon>
						<ListItemText primary={t("Blogs.Blogs")} />
					</ListItem>
				</a>
				<Link to="/Tutorial" aria-label="Help">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<ImportContactsIcon />
						</ListItemIcon>
						<ListItemText primary={t("NavBarDesktop.NavBarDesktopHelp")} />
					</ListItem>
				</Link>
				<Link
					to="/Document/How-to-Create-a-Project-in-MMA/1"
					aria-label="Guides"
				>
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<HelpIcon />
						</ListItemIcon>
						<ListItemText primary={t("Menu.Document")} />
					</ListItem>
				</Link>
			</List>
			<Divider />
			<List>
				<ListItem button onClick={(event) => handleClick(event, "Profile")}>
					<ListItemIcon>
						<AccountCircle />
					</ListItemIcon>
					<ListItemText primary={t("Menu.Profile")} />
					{Profileopen ? <ExpandLess /> : <ExpandMore />}
				</ListItem>
				<Collapse in={Profileopen}>
					<Link to="/UserProfile" aria-label="UserProfile">
						<ListItem
							button
							className={classes.nested}
							onClick={toggleDrawer("left", false)}
						>
							<ListItemIcon>
								<AccountCircle />
							</ListItemIcon>
							<ListItemText
								primary={t("NavBarDesktop.NavBarDesktopMyAccounts")}
							/>
						</ListItem>
					</Link>
					<ListItem
						button
						className={classes.nested}
						onClick={(event) => handleLogout(event)}
					>
						<ListItemIcon>
							<LockOpenIcon />
						</ListItemIcon>
						<ListItemText
							inset
							primary={t("NavBarDesktop.NavBarDesktopLogout")}
						/>
					</ListItem>
				</Collapse>
				<Link to="/Contactus" aria-label="Contactus">
					<ListItem button onClick={toggleDrawer("left", false)}>
						<ListItemIcon>
							<PhoneIcon />
						</ListItemIcon>
						<ListItemText primary={t("NavBarDesktop.NavBarDesktopContactUs")} />
					</ListItem>
				</Link>
				<ListItem button onClick={(event) => handleClick(event, "Translate")}>
					<ListItemIcon>
						<GTranslateIcon />
					</ListItemIcon>
					<ListItemText primary={t("Menu.Language")} />
					{Translateopen ? <ExpandLess /> : <ExpandMore />}
				</ListItem>
				<Collapse in={Translateopen}>
					<ListItem
						button
						className={classes.nested}
						onClick={(event) => {
							i18n.changeLanguage("en")
							toggleDrawer("left", false)
						}}
					>
						<ListItemIcon>
							<GTranslateIcon />
						</ListItemIcon>
						<ListItemText inset primary="ENG" />
					</ListItem>

					<ListItem
						button
						className={classes.nested}
						onClick={(event) => {
							i18n.changeLanguage("th")
							toggleDrawer("left", false)
						}}
					>
						<ListItemIcon>
							<GTranslateIcon />
						</ListItemIcon>
						<ListItemText inset primary="THA" />
					</ListItem>
				</Collapse>
			</List>
		</div>
	)
}
